export interface CalendarInterface {
    id: string
    pkTeamCalendar: string;
    pakistaniCalendar: string;
    holidays: string;
    weekends: string;
    workingDays: string;
}
export const calendarData: CalendarInterface[] = [
    {
        id: "1",
        pkTeamCalendar: "PK Team Calendar",
        pakistaniCalendar: "Pakistani Calendar",
        holidays: "20",
        weekends: "96",
        workingDays: "249",
    },
    {
        id: "2",
        pkTeamCalendar: "UK Team Calendar",
        pakistaniCalendar: "United Kingdom Calendar",
        holidays: "20",
        weekends: "96",
        workingDays: "249"
    },
    {
        id: "3",
        pkTeamCalendar: "UK Team Calendar",
        pakistaniCalendar: "United Kingdom Calendar",
        holidays: "20",
        weekends: "96",
        workingDays: "249"
    },
]
export const addModalCalendar = [
    "English Holiday Calendar",
    "Israel (Jewish) Holiday Calendar",
    "Empty Calendar",
    "Afghanistan Holiday Calendar",
    "Albania Holiday Calendar",
    "Algeria Holiday Calndar"
]




